import instance from './axiosInstance';

export function getAlertsSummaryData(reqBody, options = {}, http = instance) {
  return http.get('/eco2-ai-summary', reqBody, options);
}

export function getAlertDiagnosticsData(reqBody, options = {}, http = instance) {
  return http.get('/eco2-ai-diagnostics', reqBody, options);
}

export function getAlertDiagnosticsBaselineData(reqBody, options = {}, http = instance) {
  return http.get('/eco2-ai-baseline', reqBody, options);
}
